import React from 'react';

import SignedNoteSvg from 'assets/images/signed-note.svg';

import BaseIcon from './BaseIcon';

const SignedNoteIcon = props => <BaseIcon {...props} src={SignedNoteSvg} />;

export default SignedNoteIcon;
